export default __webpack_public_path__ + "static/media/template4.1f1ddee2.svg";